import { Component } from '@angular/core';
import { UrlService } from '../../../services/url.service';
import { AuthenticationService } from 'app/services/authentication.service';


@Component({
    selector: 'broad-match-toggle',
    templateUrl: 'broad-match-toggle.component.html',
})
export class BroadMatchToggleComponent {
    searchString: string;
    displayTerm: boolean;


    constructor(
        private urlService: UrlService,
        private authenticationService: AuthenticationService
    ) { }

    switchToBroadMatch() {
        if (this.urlService.queryParams['query'].indexOf('*') === -1) {
            this.searchString = this.urlService.queryParams['query'];
            if (this.searchString.indexOf(':') !== -1) {
                const queryData = this.searchString.split(':');
                this.searchString = queryData[queryData.length - 1] || '';
            }
            if (this.authenticationService.userIsResident) {
                this.urlService.updateSearchQuery(`*${this.searchString}*`, null, true);
            } else {
                this.urlService.updateSearchQuery(`*${this.searchString}*`, null, false);
            }
            this.urlService.setQueryParams(null, 1);
        }
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/broad-match-toggle/broad-match-toggle.component.ts